import cookie from "js-cookie";
import ReconnectingWebSocket from "reconnecting-websocket";
import { Notification } from "element-ui";

const idDev = process.env.NODE_ENV !== "production";

class Websocket {
  host = idDev ? "gf.szbosk.com" : window.location.host;
  //host = idDev ? "www.dy.51zhykj.com" : "www.dy.51zhykj.com";

  protocol = idDev
    ? "wss:"
    : window.location.protocol === "http:"
    ? "ws:"
    : "wss:";
  websocket = null;
  message = null;
  constructor() {
    if (!Websocket.instance) {
      this.websocketInstance();
      this.websocketOpen();
      this.websocketError();
      Websocket.instance = this;
    }
    return Websocket.instance;
  }
  websocketInstance() {
    const userName = cookie.get("userName");
    // const pathHash = window.location.hash;
    this.websocket = new ReconnectingWebSocket(
      `${this.protocol}//${this.host}/imserver/${userName}`
    );
  }
  websocketOpen() {
    this.websocket.onopen = function() {
      console.log("connect successful=>", Date.now());
    };
  }
  websocketError() {
    this.websocket.onerror = function(err) {
      console.log("connect fail=>", err);
    };
  }
  websocketListener(callback) {
    this.websocket.addEventListener("message", (event) => {
      try {
        console.log("notifcation=>", event);
        this.message = JSON.parse(event.data);
        callback(JSON.parse(event.data))
      } catch (error) {
        console.log(error);
      }
    });
  }
  unsubscribe() {
    if (this.websocket) {
      this.websocket.removeEventListener();
      this.websocket.close();
      this.websocket = null;
    }
  }
}

export default new Websocket();
